/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { get_array_of_strings_from_ml_text, str_trim, split_text_on_separators } from './util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

// import { MPlugins } from './plugins.js';
import { MDTimezones } from './timezone.js';
import { MDLocale } from './locale-impl.js';

import { MValueLists } from './meta-value-lists.js';
import { convertToSelect2WithDefaultFit } from './select2.js';

import { MVSelectMediaItems } from './select-media-items-view.js';

import { renderNutritionTableInputWidget, getNutritionTableDataFromInputWidget } from './meta-data-nutrition-table.js';
import { renderTraceElementsTableInputWidget, getTraceElementsTableDataFromInputWidget } from './meta-data-trace-elements-table.js';

/**
 * MVMediaMetadataEditWidgets - setup & manage meta data details edit view
 */
export let MVMediaMetadataEditWidgets = function($,mj) {


	function _parse_md_options0( md ) {
		const list_sep = md.options.hasOwnProperty('list_sep') && md.options.list_sep.length ? md.options.list_sep.replace(/N/g,'\n') : ',;\n';
		return {
			list_sep,
			list_sep1: list_sep.charAt(0)+' ',
		};
	}

	function _parse_md_options( md ) {
		const { list_sep, list_sep1 } = _parse_md_options0(md);
		const list_separator_mode = md.options.list_mode && md.options.list_mode==='separator';
		const vl_mode = md.options.vl_mode || 'free';
		return {
			list_sep,
			list_sep1,
			list_separator_mode,
			mvl_replace_ml_text_mode: md.type===1 && !list_separator_mode,
			vl_mode,
			vl_dropdown_enabled: vl_mode==='free' && ( md.options.vl_auto==='1' || (md.options.vl_defaults||'')!=='' )
		};
	}



	function getFormatValueFn( md ) {
		let formatValueFn = function(v) {
			return v;
		};
		if( md.type==2 || md.type==8 || md.type==3 ) {
			// INT, REF_MEDIA, REAL
			formatValueFn = MDLocale.fmt_number_input;
		}
		return formatValueFn;
	}

	function getExtractValueFn( md ) {
		let extractValueFn = (v) => v;
		switch( md.type ) {
		case 2: // MT_INT
			extractValueFn = MDLocale.xtr_number_input;
			break;
		case 3: // MT_REAL
			extractValueFn = MDLocale.xtr_number_input;
			var num_fmt = md.options.num_fmt ? md.options.num_fmt : 'normal';
			if( num_fmt==='highprec' || num_fmt==='latitude' || num_fmt==='longitude' ) {
				extractValueFn = (str) => {
					const fVal = MDLocale.xtr_number_input(str);
					return MDLocale.get_normalized_highprec_val(fVal);
				};
			}
			break;
		case 8: // MT_REF_MEDIA
			extractValueFn = MDLocale.xtr_number_input;
			break;
		}
		return extractValueFn;
	}

	function getNormalizeValueFn( md ) {
		let normalizeValueFn = null;
		if( md.type==3 ) { // MT_REAL
			const num_fmt = md.options.num_fmt ? md.options.num_fmt : 'normal';
			if( num_fmt==='highprec' || num_fmt==='latitude' || num_fmt==='longitude' ) {
				normalizeValueFn = (str) => {
					const fVal = MDLocale.xtr_number_input(str);
					return MDLocale.fmt_highprec(fVal,true);
				};
			}
		}
		return normalizeValueFn;
	}


	function prepareSelect2FromMDOptionsValueLists( md, select_elem ) {
		const vl_defaults = md.options.hasOwnProperty('vl_defaults') ? get_array_of_strings_from_ml_text(md.options.vl_defaults) : [];
		const vl_translations = md.options.hasOwnProperty('vl_translations') && md.options.vl_translations!=='' ? JSON.parse(md.options.vl_translations) : {};
		for( const iv of vl_defaults ) {
			const iv_text = vl_translations.hasOwnProperty(iv) && vl_translations[iv].hasOwnProperty(mj.locale) ? vl_translations[iv][mj.locale] : iv;
			$('<option />')
				.attr('value',iv)
				.attr('data-item',iv)	// -> this exists, so that color-flagged values can be defined once for: media-views, detail-view & edit-form, e.g.: .meta-id.meta-id-5000001 { >span.data,option { &[data-item="Value1"] {...} &[data-item="Value2"] {...} } }
				.text(iv_text)
				.appendTo(select_elem);
		}
	}




	function setupAutoMetaSuggestions( md, edit_node ) {
		if( edit_node.length===0 ) return;
		// skip unsupported types
		if( md.type!=0 && md.type!=1 ) return;
		// skip if not enabled in meta-field-config
		if( !md.options.autocomplete || md.options.autocomplete!=='1' ) return;
		// suggestions query states ...
		let sug_tracker = {
			jqxhr: null,
			text_querying: null,
			text_displaying: null,
		};
		edit_node
			.attr('autocomplete','off')
			.areacomplete( {
				wordCount: 1,
				//mode: 'outter',
				on: {
					query: function( text, cb ) {
						const lc_text = text.toLowerCase();
						if( sug_tracker.jqxhr ) {
							if( lc_text==sug_tracker.text_querying ) return; // is already querying the same text on server
							// cancel previous request ...
							sug_tracker.jqxhr.abort();
							sug_tracker.jqxhr = null;
						}
						if( lc_text.length > 1 ) {
							if( lc_text==sug_tracker.text_displaying ) return; // nothing to query right now
							sug_tracker.text_querying = lc_text;
							// query suggestion, if user typed at least 2 characters
							sug_tracker.jqxhr = $.postJSON( 'json/media/meta-matchsuggestions', 'search='+encodeURIComponent(lc_text+'*')+'&meta_id='+md.id, function(j) {
								let wl = [];
								if( j && !j.error && j.words ) wl = j.words;
								sug_tracker.jqxhr = null;
								sug_tracker.text_querying = null;
								sug_tracker.text_displaying = lc_text;
								cb(wl);
							} );
						}
					},
					selected: function( text, data ) {
						if( (md.type==0||md.type==2||md.type==3) && md.list && md.options.list_mode && md.options.list_mode==='separator' ) {
							const { list_sep1 } = _parse_md_options0(md);
							return text + list_sep1;
						}
						return text;
					},
				},
			} );
	}


	function cleanSelect2Widget( $list, destroy ) {
		$list.each( function() {
			const $elem = $(this);
			if( destroy && $elem.data('select2') ) $elem.select2('destroy');
			$elem.removeAttr('data-select2-id').removeData().find('option').removeAttr('data-select2-id').removeData();
		} );
		return $list;
	}

	function setupSelect2Widget( $list, wdgs_div ) {
		// cleanup attr and data on elements and its options
		cleanSelect2Widget($list,true);
		// create new select2 widgets
		$list.each( function() {
			const $elem = $(this);
			convertToSelect2WithDefaultFit( $elem, true, {
				// dropdownParent: wdgs_div,
				templateSelection: function _templateSelection( data, container ) {
					const dataItem = data.element && data.element.dataset && data.element.dataset.item ? data.element.dataset.item : null;
					container.attr('data-item',dataItem);
					const text = data.text ? data.text : dataItem;
					return text;
				},
			} );
		} );
		return $list;
	}

	function _xref_select_media_item_click(e) {
		const $self = $(this);
		MVSelectMediaItems.selectSingleItem( function(media_id) {
			const focus_node = $self.closest('.wrap-input').find('[name^=data]').val(media_id);
			focus_node.select();
		} );
		return false;
	}

	// helper for setting up list of input widgets:
	function setupWidgetList( md, parsedMDOpts, varray, wdgs_div, formatValueFn ) {
		const meta_id = md.id;

		wdgs_div.append('<button type="button" class="iconic add-data" title="'+mjt('md-add-value')+'"></button>');

		let inp = wdgs_div.find('[name=data]').closest('.wrap-input');
		let prev_inp = null;
		let vls = wdgs_div.find('.values-dropdown').closest('.wrap-mvl-dd');
		setupAutoMetaSuggestions(md,inp.find('[name=data]'));

		const varray_len = varray.length;
		for( var i=0; i<varray_len; ++i ) {
			const inp_select = cleanSelect2Widget(inp.children('select'),true);
			const inp2 = inp.children('input,textarea,select').attr('name','data-'+i).val(formatValueFn(varray[i])).end().clone();
			setupAutoMetaSuggestions(md,inp2.children('input,textarea'));

			inp.after(inp2);
			if( vls.length ) {
				vls = vls.children('.values-dropdown').attr('mj_target_name','data-'+i).end().clone();
				inp2.before(vls);
				MValueLists.Bind(wdgs_div,vls.children('.values-dropdown'),meta_id,parsedMDOpts.list_sep1,parsedMDOpts.mvl_replace_ml_text_mode);
			}

			const $smi = inp2.find('>.wrap-smi-trigger>.select-media-item');
			if( $smi.length ) {
				// $smi.attr('mj_target_name','data-'+i);
				$smi.on('click', _xref_select_media_item_click );
			}

			if( inp_select.length ) setupSelect2Widget(inp_select,wdgs_div);
			setupSelect2Widget(inp2.children('select'),wdgs_div);

			prev_inp = inp;
			inp = inp2;
		}
		inp.remove();
		if( vls.length ) vls.remove();

		wdgs_div.find('.add-data').click( function _add_list_item() {
			let imax = 0;
			wdgs_div.find('[name^=data-]').each(function() {
				const listpos = parseInt($(this).attr('name').toString().substr(5),10);
				if( listpos>imax ) imax = listpos;
			});

			const inp = wdgs_div.find('[name=data-'+imax.toString()+']').closest('.wrap-input');
			const inp_select = cleanSelect2Widget(inp.children('select'),true);
			const inp2 = inp.clone().children('input,textarea,select').attr('name','data-'+(imax+1).toString()).val(formatValueFn('')).end();

			setupAutoMetaSuggestions(md,inp2.children('input,textarea'));
			inp.after(inp2);
			let vls = wdgs_div.find('.values-dropdown[mj_target_name=data-'+imax.toString()+']').closest('.wrap-mvl-dd');
			if( vls.length ) {
				vls = vls.clone().children('.values-dropdown').attr('mj_target_name','data-'+(imax+1).toString()).end();
				inp2.before(vls);
				MValueLists.Bind(wdgs_div,vls.children('.values-dropdown'),meta_id,parsedMDOpts.list_sep1,parsedMDOpts.mvl_replace_ml_text_mode);
			}

			const $smi = inp2.find('>.wrap-smi-trigger>.select-media-item');
			if( $smi.length ) {
				// $smi.attr('mj_target_name','data-'+(imax+1));
				$smi.on('click', _xref_select_media_item_click );
			}

			if( inp_select.length ) setupSelect2Widget(inp_select,wdgs_div);
			setupSelect2Widget(inp2.children('select'),wdgs_div);

			inp2.children('input,textarea,select').focus();
		} );

		return prev_inp ? prev_inp.children('input,textarea,select') : null;
	}

	function setupFixedVLModeWidget( md, parsedMDOpts, varray, wdgs_div, formatValueFn ) {
		// single dropdown or multiple dropdowns (values from vl_defaults..)
		const xstyle = md.type==2 ? 'style="width:85px"' : ( md.type==3 ? 'style="max-width:125px"' : '' );	// INT, REAL
		wdgs_div.html('<div class="wrap-input"><select size="1" name="data" '+xstyle+'><option value="" data-item=""></option></select></div>');
		const select_elem = wdgs_div.find('[name=data]');
		prepareSelect2FromMDOptionsValueLists(md,select_elem);
		let focus_node = null;
		if( md.list ) {
			focus_node = setupWidgetList(md,parsedMDOpts,varray,wdgs_div,formatValueFn);
		} else {
			const vfirst = varray[0];
			const vstring = formatValueFn(vfirst);
			focus_node = wdgs_div.find('[name=data]').val(vstring);
		}
		setupSelect2Widget(select_elem,wdgs_div);
		return focus_node;
	}




	function setupCommonMetadataEditWidget( md, wdgs_div, focus_node, varray ) {
		const meta_id = md.id;
		const parsedMDOpts = _parse_md_options(md);

		const formatValueFn = getFormatValueFn(md);

		if( parsedMDOpts.vl_mode==='fixed' ) {

			focus_node = setupFixedVLModeWidget(md,parsedMDOpts,varray,wdgs_div,formatValueFn);

		} else if( md.type!=1 && md.list && parsedMDOpts.list_separator_mode ) {
			// one multiline-text-field, (configurable-)separator-separated
			wdgs_div.html('<div class="wrap-input"><textarea class="text" name="data" cols="20" rows="8">\n</textarea></div>');
			if( parsedMDOpts.vl_dropdown_enabled ) {
				wdgs_div.prepend(MValueLists.getTriggerHTML());
				MValueLists.Bind(wdgs_div,wdgs_div.find('.values-dropdown'),meta_id,parsedMDOpts.list_sep1,parsedMDOpts.mvl_replace_ml_text_mode);
			}
			let vstring = '';
			const varray_len = varray.length;
			for( var i=0; i<varray_len; ++i ) {
				if( vstring!='' ) vstring += parsedMDOpts.list_sep1;
				vstring += formatValueFn(varray[i]);
			}
			focus_node = wdgs_div.find('[name=data]').val(vstring);
			setupAutoMetaSuggestions(md,focus_node);

		} else {
			if( md.type==1 ) {
				// single or multiple multi-line fields
				wdgs_div.html('<div class="wrap-input"><textarea class="text" name="data" cols="20" rows="8">\n</textarea></div>');
			} else {
				// single or multiple single-line fields
				const xstyle = md.type==2 || md.type==8 ? 'style="width:85px"' : ( md.type==3 ? 'style="max-width:125px"' : '' ); // INT, REF_MEDIA, REAL
				wdgs_div.html('<div class="wrap-input"><input class="text" type="text" name="data" '+xstyle+'/></div>');
			}

			if( parsedMDOpts.vl_dropdown_enabled ) {
				wdgs_div.prepend(MValueLists.getTriggerHTML());
				MValueLists.Bind(wdgs_div,wdgs_div.find('.values-dropdown'),meta_id,parsedMDOpts.list_sep1,parsedMDOpts.mvl_replace_ml_text_mode);
			}


			if( md.type==8 ) {
				const wrapper_div = wdgs_div.find('.wrap-input');
				wrapper_div.append('<div class="wrap-smi-trigger"><span class="select-media-item" title="'+mjt('md-select-media-item')+'"></span></div>');
				wrapper_div.find('>.wrap-smi-trigger>.select-media-item').on('click', _xref_select_media_item_click );
			}


			if( md.list ) {
				focus_node = setupWidgetList(md,parsedMDOpts,varray,wdgs_div,formatValueFn);
			} else {
				const vfirst = varray[0];
				const vstring = formatValueFn(vfirst);
				focus_node = wdgs_div.find('[name=data]').val(vstring);
				setupAutoMetaSuggestions(md,focus_node);
			}

			if( md.type==2 ) {				// INT
				focus_node.numeric({decimal:false});
			} else if( md.type==8 ) {		// REF_MEDIA
				focus_node.numeric({decimal:false,negative:false});
			} else if( md.type==3 ) {		// REAL
				const normalizeValueFn = getNormalizeValueFn(md);
				focus_node.numeric( {
					decimal: MDLocale.decimal_point_char,
					cleanPastedTextFn: (str) => {
						return MDLocale.fmt_number_input(str);
					},
					normalizeValueFn,
				} );
			}
		}

		// set auto-height for textareas:
		wdgs_div.find('textarea.text').each( function() {
			const $textarea = $(this);
			const name = $textarea.prop('name');
			if( name.startsWith('data') ) {
				$textarea.css({
					'height': 'auto',
				} );
				const newHeight = Math.min( ($textarea[0].scrollHeight - $textarea[0].offsetHeight + $textarea[0].clientHeight + 24), 500 );
				const curHeight = $textarea.height();
				if( newHeight > curHeight ) {
					$textarea.css('height',Math.round(newHeight)+'px');
				}
			}
		} );
		return focus_node;
	}

	function setupMetadataEditWidget( md, btns_div, wdgs_div, focus_node, varray ) {
		let vfirst = varray[0];

		// add field, depending on meta-data type
		switch( md.type ) {
		case 0: // MT_STRING
		case 1: // MT_TEXT
		case 2: // MT_INT
		case 3: // MT_REAL
		case 8: // MT_REF_MEDIA
			focus_node = setupCommonMetadataEditWidget(md,wdgs_div,focus_node,varray);
			break;
		case 4: // MT_BINARY
			// not editable
			if( btns_div ) btns_div.empty();
			wdgs_div.html('-binary-data-');
			break;
		case 5: // MT_DATE - date selector
			focus_node = wdgs_div.html('<input type="hidden" name="data" /><input class="text date" type="text" name="data-date" />')
				.find('[name=data]').val(vfirst).end()
				.find('[name=data-date]').val(MDLocale.fmt_date(vfirst)).datepicker();
			break;
		case 6: // MT_TIME - time selector
			focus_node = wdgs_div.html('<input class="text time" type="text" name="data" />')
				.find('[name=data]').val(MDLocale.fmt_time(vfirst));
			break;
		case 7: // MT_DATETIME - date+time selector
			wdgs_div.html( '<input type="hidden" name="data" />'
							+ '<input class="text date" type="text" name="data-date" />'
							+ '&nbsp;<input class="text time" type="text" name="data-time" />'
							+ '<span class="reset-time" tabindex="0"></span>' );
			var vdate, vtime;
			if( vfirst.length===10 ) {
				// date only
				vdate = MDLocale.fmt_date(vfirst);
				vtime = '';
			} else {
				// date+time
				vfirst = MDTimezones.datetime_utc2local(vfirst);
				vdate = MDLocale.fmt_date(vfirst);
				vtime = MDLocale.fmt_time(vfirst);
			}
			focus_node = wdgs_div.find('[name=data]').val(vfirst).end()
				.find('[name=data-time]').val(vtime).end()
				.find('.reset-time').click( function() {
					wdgs_div.find('[name=data-time]').val('');
				} ).end()
				.find('[name=data-date]').val(vdate).datepicker();
			break;
		case 9: // MT_OBJECT
			{
				const object_sub_type = md.hasOwnProperty('options') && md.options.hasOwnProperty('object_sub_type') ? md.options.object_sub_type : '';
				if( object_sub_type==='nutrition-table' ) {
					const table = vfirst==='' || vfirst===null ? {} : JSON.parse(vfirst);
					renderNutritionTableInputWidget(wdgs_div,table);
					focus_node = wdgs_div.find('input:text').first();
					break;
				} else if( object_sub_type==='trace-elements-table' ) {
					const table = vfirst==='' || vfirst===null ? {} : JSON.parse(vfirst);
					renderTraceElementsTableInputWidget(wdgs_div,table);
					focus_node = wdgs_div.find('input:text').first();
					break;
				}
			}
			// not implemented yet
			if( btns_div ) btns_div.empty();
			wdgs_div.html('-object-data-');
			break;
		}

		wdgs_div.on( 'keydown.MVDetail', 'input[type=text],textarea', function _widget_keydown(e) {
			if( !e.isDefaultPrevented() && e.which===13 && ( e.ctrlKey || e.metaKey || e.shiftKey ) ) {
				// submit form
				$(this).closest('form').submit();
				e.preventDefault();
				e.stopPropagation();
			}
		} );

		return focus_node;
	}





	function getMetadataEditWidgetData( md, wdgs_div ) {
		switch( md.type ) {
		case 0: // MT_STRING
		case 1: // MT_TEXT
		case 2: // MT_INT
		case 3: // MT_REAL
		case 8: // MT_REF_MEDIA
			var extractValueFn = getExtractValueFn(md);
			if( md.list ) {
				if( md.type!=1 && md.options.list_mode && md.options.list_mode==='separator' ) {
					// list, single input field, but with separator character
					const { list_sep } = _parse_md_options0(md);
					const dtmp = split_text_on_separators( wdgs_div.find('[name=data]').val(), list_sep, extractValueFn );
					return dtmp.length===0 ? [''] : dtmp;
				}
				// list, multiple input fields
				let dtmp = [];
				wdgs_div.find('[name^=data-]').each( function() {
					const v = extractValueFn(str_trim($(this).val())).toString();
					if( v.length ) dtmp.push(v);
				} );
				return dtmp.length===0 ? [''] : dtmp;
			}
			// single value
			return [ extractValueFn(str_trim(wdgs_div.find('[name=data]').val())).toString() ];
		case 4: // MT_BINARY
			// not editable yet
			break;
		case 5: // MT_DATE - date selector
			return [ MDLocale.xtr_date(wdgs_div.find('[name=data-date]').val()) ];
		case 6: // MT_TIME - time selector
			return [ MDLocale.xtr_time(wdgs_div.find('[name=data-time]').val()) ];
		case 7: // MT_DATETIME - date+time selector
			var vdate=str_trim(wdgs_div.find('[name=data-date]').val());
			var vtime=str_trim(wdgs_div.find('[name=data-time]').val());
			// date only - parse, no utc conversion
			if( vtime=='' ) return [ MDLocale.xtr_date(vdate) ];
			// date+time -> parse & convert to utc
			return [ MDTimezones.datetime_local2utc(MDLocale.xtr_datetime(vdate,vtime)) ];
		case 9: // MT_OBJECT
			{
				const object_sub_type = md.hasOwnProperty('options') && md.options.hasOwnProperty('object_sub_type') ? md.options.object_sub_type : '';
				if( object_sub_type==='nutrition-table' ) {
					const table = getNutritionTableDataFromInputWidget(wdgs_div);
					return [ JSON.stringify(table) ];
				} else if( object_sub_type==='trace-elements-table' ) {
					const table = getTraceElementsTableDataFromInputWidget(wdgs_div);
					return [ JSON.stringify(table) ];
				}
			}
			// not editable yet
			break;
		default: // unknown
			// not editable yet
		}
		return [];
	}



	function setupAdd2AllOpenFilesWidget( md, editItemForm, onSubmit ) {
		const meta_id = md.id;
		const parsedMDOpts = _parse_md_options(md);

		let _html_tmp = '';
		_html_tmp += '<form class="edit-add2all-form" method="post" accept-charset="UTF-8">';
		_html_tmp += '<div class="form-label">'+mjt('md-add2all-label')+'</div>';
		_html_tmp += '<div class="edit-widgets"><div class="wrap-input"></div></div>';
		_html_tmp += '<div class="edit-buttons">';
		_html_tmp += '<button type="submit" class="iconic submit" title="'+mjt('md-add2all-save')+'" disabled></button>';
		_html_tmp += '</div>';
		_html_tmp += '</form>';
		const add2AllForm = editItemForm.after(_html_tmp).nextAll('form.edit-add2all-form');
		const wdgs_div = add2AllForm.children('.edit-widgets');
		const wdg_wrapper = wdgs_div.children('.wrap-input');

		// MT_STRING, MT_TEXT, MT_INT, MT_REF_MEDIA, MT_REAL
		// eslint-disable-next-line no-lonely-if
		if( parsedMDOpts.vl_mode==='fixed' ) {
			// input using dropdown (values from vl_defaults..)
			const xstyle = md.type==2 || md.type==8 ? 'style="width:85px"' : ( md.type==3 ? 'style="max-width:125px"' : '' );	// INT, REF_MEDIA, REAL
			const select_elem = wdg_wrapper.html('<select size="1" name="add-data" '+xstyle+'><option value="" data-item=""></option></select>').children('select');
			prepareSelect2FromMDOptionsValueLists(md,select_elem);
			convertToSelect2WithDefaultFit( select_elem, true, {
				// dropdownParent: wdgs_div
			} );
		} else {
			// free text input
			if( md.type==1 ) {
				// MT_TEXT
				// multiline-text-field
				wdg_wrapper.html('<textarea rows="2" cols="20" name="add-data" class="text"></textarea>');
			} else if( parsedMDOpts.list_separator_mode ) {
				// multiline-text-field, (configurable-)separator-separated
				wdg_wrapper.html('<textarea rows="2" cols="20" name="add-data" class="text"></textarea>');
			} else {
				// single-line field
				wdg_wrapper.html('<input type="text" name="add-data" class="text">');
			}
		}

		if( parsedMDOpts.vl_dropdown_enabled && ( md.type===1 || ( md.type!==1 && parsedMDOpts.vl_mode!=='fixed' ) ) ) {
			wdgs_div.prepend(MValueLists.getTriggerHTML());
			const mvl_dd = wdgs_div.find('.values-dropdown').attr('mj_target_name','add-data');
			MValueLists.Bind(wdgs_div,mvl_dd,meta_id,parsedMDOpts.list_sep1,parsedMDOpts.mvl_replace_ml_text_mode);
		}
		const wdg_elem = wdg_wrapper.children('[name=add-data]');
		const submit_btn = add2AllForm.children('.edit-buttons').children('.submit');
		wdg_elem.on('change keyup onpaste focus',function() {
			submit_btn.prop('disabled',str_trim(wdg_elem.val())=='');
		});
		add2AllForm.submit( function() {
			let data2AddArr=[];
			const raw_value = wdg_elem.val();
			if( md.type==1 ) {
				data2AddArr.push(raw_value);
			} else {
				const extractValueFn = getExtractValueFn(md);
				if( parsedMDOpts.list_separator_mode ) {
					data2AddArr = split_text_on_separators(raw_value,parsedMDOpts.list_sep,extractValueFn);
				} else {
					data2AddArr.push( extractValueFn(str_trim(raw_value)).toString() );
				}
			}
			if( data2AddArr.length===0 || data2AddArr[0]==='' ) {
				// empty input ? then nothing to add here ...
				return false;
			}
			onSubmit( data2AddArr );
			return false;
		} );
	}



	return {
		setupMetadataEditWidget,
		getMetadataEditWidgetData,

		setupAdd2AllOpenFilesWidget,
	};
}(jQuery,mj); // namespace MVMediaMetadataEditWidgets
